import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Lottie from 'lottie-react';
import React, { useEffect, useState } from 'react';
// import Slider from "react-slick";

import { AppDispatch } from '../../../core/data/redux/store';
import { RootState } from '../../../core/data/redux/store';
import { validatePassword } from '../../../core/data/redux/action';
import Loader from '../../../core/data/img/car_loading.json';

export const BookingAttachment = ({ booking }: { booking: any }) => {
  const { error, systemSettings, passwordAuthenticate, bookingDetailLoading } =
    useSelector((state: RootState) => ({
      bookingDetailLoading: state.booking.bookingDetailLoading,
      passwordAuthenticate: state.auth.passwordAuthenticate,
      systemSettings: state.auth.systemSettings,

      error: state.auth.error,
    }));

  // const sliderRef = useRef(null);

  // const settings = {
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   asNavFor: sliderRef.current || undefined, // Link to the second slider
  //   ref: (slider: any) => (sliderRef.current = slider), // Assign the slider ref
  // };

  const dispatch = useDispatch<AppDispatch>();

  const [passwordInput, setPasswordInput] = useState('');

  const [isToggle, setIsToggle] = useState(false);

  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(
      validatePassword({
        password: passwordInput,
      })
    );
  };

  useEffect(() => {
    if (error) {
      showToast(error);
    }
  }, [error]);

  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');

  const showToast = (message: any) => {
    setToastClass(error ? 'bg-danger text-white' : 'bg-success text-white');
    setToastMessage(message);
  };

  const handleCloseToast = () => {
    setToastMessage('');
  };

  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      } else {
        toast.success(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      }
    }
  }, [toastMessage, toastClass]);

   

  return (
    <>
      {
        <>
          <div
            className="modal new-modal multi-step fade"
            id="view_attachment"
            data-keyboard="false"
            data-backdrop="static"
          >
            <div className="modal-dialog  modal-lg">
              <div className="modal-content">
                <div className="modal-header p-0 m-0 border-0">
                  <button
                    type="button"
                    className="close-btn"
                    data-bs-dismiss="modal"
                  >
                    <span>×</span>
                  </button>
                </div>
                <div className="modal-body">
                  {bookingDetailLoading ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <Lottie
                        animationData={Loader}
                        loop={true}
                        style={{ width: 300, height: 300 }}
                      />
                    </div>
                  ) : (
                    <>
                      <div>
                        {systemSettings?.booking_attachment_password ===
                          'true' && !passwordAuthenticate ? (
                          <div className="px-2 py-2">
                            <div>
                              <h6> </h6>
                            </div>
                            <div
                              style={{
                                // width: "80%",
                                height: '500',
                              }}
                            >
                              <form
                                onSubmit={handlePasswordSubmit}
                                className=""
                              >
                                <div className="pass-group">
                                  <input
                                    type={isToggle ? 'text' : 'password'}
                                    className={`form-control pass-input-three my-1 py-2`}
                                    placeholder="Enter password to unlock"
                                    onChange={(e) => {
                                      setPasswordInput(e.target.value);
                                    }}
                                  />
                                  <span
                                    onClick={() => setIsToggle(!isToggle)}
                                    className={`fas toggle-password ${isToggle ? 'fa-eye' : 'fa-eye-slash'}`}
                                  />
                                </div>

                                <button
                                  type="submit"
                                  className="btn btn-primary w-100 btn-size my-1 py-1"
                                >
                                  Unlock
                                </button>
                              </form>
                            </div>
                          </div>
                        ) : (
                          booking?.bookingattachments
                            ?.filter((item: any) =>
                              booking.final_agreement_status === 'approved'
                                ? item.verification?.verification ===
                                    'final_agreement'  
                                : item.verification?.verification ===
                                  'agreement'
                            )
                            ?.map((slide: any, index: number) => {
                              const fileType = slide.type || '';
                              const isImage = fileType.startsWith('image');
                              const isPdf = fileType.startsWith('pdf');

                              return (
                                <div className="text-center" key={index}>
                                  <div className="slide-container">
                                    {isImage ? (
                                      <img
                                        src={slide.file_url}
                                        alt={slide.name}
                                        className="slide-image"
                                      />
                                    ) : isPdf ? (
                                      <iframe
                                        src={slide.file_url}
                                        className="slide-iframe"
                                      />
                                    ) : (
                                      <a
                                        href={slide.file_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        View File
                                      </a>
                                    )}
                                  </div>
                                  <h6 className="mt-2">{slide.name}</h6>
                                </div>
                              );
                            })
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal new-modal multi-step fade"
            id="view_insurance"
            data-keyboard="false"
            data-backdrop="static"
          >
            <div className="modal-dialog  modal-lg">
              <div className="modal-content">
                <div className="modal-header p-0 m-0 border-0">
                  <button
                    type="button"
                    className="close-btn"
                    data-bs-dismiss="modal"
                  >
                    <span>×</span>
                  </button>
                </div>
                <div className="modal-body">
                  {bookingDetailLoading ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <Lottie
                        animationData={Loader}
                        loop={true}
                        style={{ width: 300, height: 300 }}
                      />
                    </div>
                  ) : (
                    <>
                      <div>
                        {systemSettings?.booking_attachment_password ===
                          'true' && !passwordAuthenticate ? (
                          <div className="px-2 py-2">
                            <div>
                              <h6> </h6>
                            </div>
                            <div
                              style={{
                                // width: "80%",
                                height: '500',
                              }}
                            >
                              <form
                                onSubmit={handlePasswordSubmit}
                                className=""
                              >
                                <div className="pass-group">
                                  <input
                                    type={isToggle ? 'text' : 'password'}
                                    className={`form-control pass-input-three my-1 py-2`}
                                    placeholder="Enter password to unlock"
                                    onChange={(e) => {
                                      setPasswordInput(e.target.value);
                                    }}
                                  />
                                  <span
                                    onClick={() => setIsToggle(!isToggle)}
                                    className={`fas toggle-password ${isToggle ? 'fa-eye' : 'fa-eye-slash'}`}
                                  />
                                </div>

                                <button
                                  type="submit"
                                  className="btn btn-primary w-100 btn-size my-1 py-1"
                                >
                                  Unlock
                                </button>
                              </form>
                            </div>
                          </div>
                        ) : (
                          booking?.bookingattachments
                            ?.filter(
                              (item: any) =>
                                item.verification?.verification === 'insurance'
                            )
                            ?.map((slide: any, index: number) => {
                              const fileType = slide.type || '';
                              const isImage = fileType.startsWith('image');
                              const isPdf = fileType.startsWith('pdf');

                              return (
                                <div className="text-center" key={index}>
                                  <div className="slide-container">
                                    {isImage ? (
                                      <img
                                        src={slide.file_url}
                                        alt={slide.name}
                                        className="slide-image"
                                      />
                                    ) : isPdf ? (
                                      <iframe
                                        src={slide.file_url}
                                        className="slide-iframe"
                                      />
                                    ) : (
                                      <a
                                        href={slide.file_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        View File
                                      </a>
                                    )}
                                  </div>
                                  <h6 className="mt-2">{slide.name}</h6>
                                </div>
                              );
                            })
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
};

export default BookingAttachment;
